import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeNotification, {
  moleculeNotificationAutoClose,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'

const NotificationReservationStatus = ({notificationData = {}}) => {
  const {i18n} = useContext(Context)
  const notificationDataAvailable = Object.values(notificationData).length > 0

  const notificationReservationStatusContent = cx('mt-NotificationReservationStatus-content', {
    'is-success': notificationDataAvailable && notificationData.type === 'success'
  })

  const {Icon, text, type} = notificationDataAvailable && notificationData

  return (
    <>
      {notificationDataAvailable && (
        <div className="mt-NotificationReservationStatus">
          <MoleculeNotification
            autoClose={moleculeNotificationAutoClose.manual}
            icon={<Icon size={ATOM_ICON_SIZES.medium} />}
            roundedCorners={moleculeNotificationBorderSizes.medium}
            showCloseButton={false}
            showLeftIconMobile
            type={moleculeNotificationTypes[type]}
            variation={moleculeNotificationVariations.positive}
          >
            <div className={notificationReservationStatusContent}>
              <span>{i18n.t(text)}</span>
            </div>
          </MoleculeNotification>
        </div>
      )}
    </>
  )
}

NotificationReservationStatus.displayName = 'NotificationReservationStatus'
NotificationReservationStatus.propTypes = {
  notificationData: PropTypes.object
}
export default NotificationReservationStatus
